<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId")
      button.button.small(slot="trigger") Segment attributes
      label Attributes
      Attributes(v-model="body.attributes", :save-action="updateAttribute", :delete-action="deleteAttribute" )

</template>

<script>
import ModalReveal from "../../components/structure/foundation/ModalReveal";
import Attributes from "../../components/backoffice/tabbed/Attributes";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import MaggieHelper from "../../maggieHelper";

export default {
  name: "SegmentAttributesReveal",
  components: {Attributes, ModalReveal},
  data() {
    return {
      body: {
        attributes: this.segment.attributes
      }
    }
  },
  methods: {
    updateAttribute(attribute) {
      if (attribute.id) {
        return KeplerBackofficeSdk.segmentAttributes.select(attribute.id).edit({value: attribute.value}, (data) => {
          return data
        })
      }
      attribute.segment_id = this.segment.id
      return KeplerBackofficeSdk.segmentAttributes.make(attribute, (data) => {
        this.body.attributes[this.body.attributes.length - 1].id = data.id
        return data
      })
    },
    deleteAttribute(attribute) {
      return KeplerBackofficeSdk.segmentAttributes.select(attribute.id).delete(() => {
        MaggieHelper.notification('attribute', 'Attribute deleted')
      })
    }
  },

  computed: {
    componentId() {
      return this.segment !== null ? `segmentAttributeReveal-${this.segment.id}` : `segmentAttributeReveal-${this._uid}`
    },

  },

  props: {
    segment: {
      type: Object,
      default: null
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SegmentAttributesReveal.vue?75207b95